var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.sortedGroupedProperties, function (propertyGroup, index) {
        return [
          _c("order-property-list-group-custom", {
            key: propertyGroup.id,
            attrs: {
              "padding-classes": _vm.paddingClasses,
              "padding-inline-styles": _vm.paddingInlineStyles,
              "property-group": propertyGroup,
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }